import { render, staticRenderFns } from "./TenantCustom.vue?vue&type=template&id=a761163a&scoped=true&"
import script from "./TenantCustom.vue?vue&type=script&lang=js&"
export * from "./TenantCustom.vue?vue&type=script&lang=js&"
import style0 from "./TenantCustom.vue?vue&type=style&index=0&id=a761163a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a761163a",
  null
  
)

export default component.exports